import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Tooltip, Typography, Checkbox, CardMedia } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import ProgressOverlay from './ProgressOverlay';


const folderWidth = 172;
const folderHeight = 138;

const cardWidth = 172;
const cardHeight = 200;

const useStyles = makeStyles((theme) => ({
  card: {
    width: cardWidth,
    height: cardHeight,
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(3),
    position: 'relative',
  },
  cardHeader: {
    color: '#555',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    zIndex: '1',
    '&:hover': {
      position: 'relative',
      flexWrap: 'wrap',
      overflow: 'visible',
      zIndex: '2',
    },
  },
  cardHeaderSpan: {
    '&:hover': {
      display: 'inline-block',
      paddingRight: '40px !important',
      background: 'linear-gradient(270deg, ' +
        'rgba(250,250,250,0) 0%, ' +
        'rgba(250,250,250,1) 25px, ' +
        'rgba(250,250,250,1) 100%)',
    },
  },
  cardImageContainer: {
    position: 'absolute',
    top: '26px',
    marginLeft: '10px',
    marginRight: '10px',
    cursor: 'pointer',
    display: 'block',
    height: '105px',
    overflow: 'hidden',
  },
  selectOverlay: {
    position: 'absolute',
    top: '-4px',
    left: '-4px',
  },
  checkBox: {
    opacity: '0.85',
    '&:hover': {
      opacity: '1.0',
    },
  },
  checkBoxIcon: {
    color: theme.palette.primary.main,
    backgroundColor: '#fff',
    opacity: '1.0',
  },
  checkBoxOutlineIcon: {
    color: '#ffffffcc',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  thumbnailGrid: {
    marginBottom: theme.spacing(3),
  },
  regularWidth: {
    margin: '2.5px',
  },
  image: {
    height: '40px',
    width: '70px',
  },
  smallImage: {
    height: '25px',
    width: '45.5px',
  },
  folder: {
    position: 'relative',
    width: folderWidth,
    cursor: 'pointer',
  },
  overlay: {
    position: 'absolute',
    left: '0',
    bottom: '0',
    height: '11px',
    width: '100%',
    display: 'flex',
    background: 'linear-gradient(' +
      'rgba(230,231,238,0) 0%, ' +
      'rgba(230,231,238,1) 100%)',
  },
}));

export default function GalleryFolder(props) {
  const { name, materials, thumbnailUrls, setFolder } = props;

  const classes = useStyles();
  const [navigatingClick, setNavigatingClick] = useState(false);
  const [imageCode, setImageCode] = useState('');

  const smallGrid = true;  // materials.length > 6;

  function handleClick() {
    setNavigatingClick(true);
    setFolder(name);
  }

  useEffect(() => {
    async function getThumbnails(inputMats, thumbnailUrls) {
      const inputMids = inputMats.map(mat => mat ? mat.materialId : null);
      if (!ignore) {
        const thumbnails = inputMids.map(mid => mid ? thumbnailUrls[mid] : '');
        if (thumbnails && thumbnails.length > 0) {
          setImageCode(
            <Grid container spacing={0} className={classes.thumbnailGrid}>
              {thumbnails.map((t, i) =>
                <React.Fragment key={i}>
                  <Grid item className={classes.regularWidth}>
                    <Tooltip title={inputMids[i] ? inputMats[i].name : 'input not available'}>
                    {t ? (
                      <CardMedia
                        className={`${smallGrid ? classes.smallImage : classes.image}`}
                        image={t}
                      />
                    ) : <></>}
                    </Tooltip>
                  </Grid>
                </React.Fragment>
              )}
            </Grid>
          );
        }
      }
    }

    let ignore = false;
    if (materials && thumbnailUrls) {
      if (materials.length > 0) {
        getThumbnails(materials, thumbnailUrls);
      }
    }
    return () => { ignore = true; }
  }, [materials, thumbnailUrls]);

  return (<>
    <Grid item className={classes.card}>
      <div className={classes.folder}>
        <img
          src='folder.512x410.png'
          className={classes.folder}
          onClick={handleClick}
        />
      </div>
      <div
        className={classes.cardImageContainer}
        onClick={handleClick}
      >
        <Grid container>
          <Grid item xs={12}>
            {imageCode}
          </Grid>
          <Grid item className={classes.overlay} />
        </Grid>
        {/* <div className={classes.selectOverlay}>
          <Checkbox className={classes.checkBox}
            checked={selected}
            checkedIcon={<CheckBoxIcon className={classes.checkBoxIcon} />}
            icon={<CheckBoxOutlineIcon className={classes.checkBoxOutlineIcon} />}
            onClick={(event) => onSelect(event, material.materialId)}
          />
        </div> */}
        {navigatingClick && <ProgressOverlay />}
      </div>
      <Typography noWrap variant='h4' className={classes.cardHeader}>
        <span className={classes.cardHeaderSpan}>
          {name}
        </span>
      </Typography>
      {materials && materials.length > 0 && (
        <Typography noWrap variant='body2' className={classes.cardHeader}>
          {materials.length} material{materials.length !== 1 && 's'}
        </Typography>
      )}
    </Grid>
  </>);
}
